<template>
  <div class="w-100">

    <form v-show="canWrite" @submit.prevent="saveForm">
      <h2 class="mb-3">Einlagerung</h2>

      <div v-if="showBruttoTara || batch.productId > 1" class="row">
        <div class="input-group col-6 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="grossWeight">Brutto-Gewicht</label>
          </div>
          <input v-model="grossWeight" type="number" step=".01" class="form-control form-control-lg"
                 id="grossWeight" placeholder="" @change="setGrossDateTime()">
          <div class="input-group-append">
            <span class="input-group-text">kg</span>
          </div>
        </div>
        <div class="input-group col-2 mb-3">
          <button @click="getWeightFromScale('grossWeight')" class="group-btn" type="button">Waage</button>
        </div>
        <div v-if="scaleData.grossWeightOutput" class="input-group col-8 mb-3 pl-3">
          {{ scaleData.grossWeightOutput }}
        </div>

        <div class="input-group col-4 w55 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="grossWeightDate">D</label>
          </div>
          <input v-model="grossWeightDate" class="form-control form-control-lg"
                 id="grossWeightDate" placeholder="TT.MM.JJJJ" pattern="\d{1,2}.\d{1,2}.\d{4}">
        </div>
        <div class="input-group col-4 w45 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="grossWeightTime">Z</label>
          </div>
          <input v-model="grossWeightTime" class="form-control form-control-lg"
                 id="grossWeightTime" placeholder="HH:mm">
        </div>

        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="licensePlateNumber">Kennzeichen</label>
          </div>
          <input v-model="licensePlateNumber" class="form-control form-control-lg" id="licensePlateNumber" placeholder="">
        </div>

        <div class="input-group col-6 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="tareWeight">Tara-Gewicht</label>
          </div>
          <input v-model="tareWeight" type="number" step=".01" class="form-control form-control-lg"
                 id="tareWeight" placeholder="" @change="setTaraDateTime()">
          <div class="input-group-append">
            <span class="input-group-text">kg</span>
          </div>
        </div>
        <div class="input-group col-2 mb-3">
          <button @click="getWeightFromScale('tareWeight')" class="group-btn" type="button">Waage</button>
        </div>
        <div v-if="scaleData.tareWeightOutput" class="input-group col-8 mb-3 pl-3">
          {{ scaleData.tareWeightOutput }}
        </div>

        <div class="input-group col-4 w55 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="tareWeightDate">D</label>
          </div>
          <input v-model="tareWeightDate" class="form-control form-control-lg"
                 id="tareWeightDate" placeholder="TT.MM.JJJJ" pattern="\d{1,2}.\d{1,2}.\d{4}">
        </div>
        <div class="input-group col-4 w45 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="tareWeightTime">Z</label>
          </div>
          <input v-model="tareWeightTime" class="form-control form-control-lg"
                 id="tareWeightTime" placeholder="HH:mm">
        </div>

      </div>

      <div v-if="isPumpkin" class="row">
        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="breed">Sorte</label>
          </div>
          <input v-model="breed" class="form-control form-control-lg" id="breed" placeholder="">
        </div>
      </div>

      <div class="row">
        <div v-if="showBatchSampleNumber" class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="sampleNumber">Probe Nr</label>
          </div>
          <input v-model="sampleNumber" class="form-control form-control-lg" id="sampleNumber" placeholder="">
        </div>
      </div>

      <div v-if="isGrain" class="row">
        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="dockage">Besatz</label>
          </div>
          <input v-model="dockage" type="number" step=".01" class="form-control form-control-lg"
                 id="tareWeight" placeholder="">
          <div class="input-group-append">
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="moisture">Feuchtigkeit</label>
          </div>
          <input v-model="moisture" type="number" step=".01" class="form-control form-control-lg"
                 id="moisture" placeholder="">
          <div class="input-group-append">
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="hectoliter">Hektoliter</label>
          </div>
          <input v-model="hectoliter" type="number" step=".01" class="form-control form-control-lg"
                 id="hectoliter" placeholder="">
          <div class="input-group-append">
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="protein">Protein</label>
          </div>
          <input v-model="protein" type="number" step=".01" class="form-control form-control-lg"
                 id="protein" placeholder="">
          <div class="input-group-append">
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="stockLocation">Lagerort</label>
          </div>
          <input
              v-if="!stores"
              v-model="stockLocation" class="form-control form-control-lg"
                 id="stockLocation" placeholder="">
          <select v-else
                  v-model="stockLocation"
                  class="custom-select custom-select-lg" id="stockLocation">
            <option
                v-for="(item,index) in stores"
                :key="index"
                :value="item">{{ getStockLabel(item) }}</option>
          </select>
        </div>
      </div>
    </form>

    <workflow-notes :note-data="noteData" :can-write="canWrite"/>

    <div v-if="storedData" class="col-8 mt-3 text-right">
      <img class="opened" src="@/assets/images/icon-done.svg"/>
      gespeichert
    </div>
    <button @click="storeWorkflowData" class="mt-5 mb-3" type="button">Zwischenspeichern</button>

    <div
      v-if="grossWeight && tareWeight"
      class="row">
      <h2>Gewicht</h2>
      <ul class="output col-8">
        <li class="bold">
          <label class="col-3 bold">Netto</label> {{ globalFunctions.parseNumber(totalWeight()) }} kg
        </li>
        <li
            v-if="dockage"
            class="bold">
          <label class="col-3 bold">- Besatz</label> {{ globalFunctions.parseNumber(totalMinusDockage()) }} kg
        </li>
      </ul>
    </div>

    <button v-show="canWrite" @click="finishWorkflowStep" type="button" class="done">Einlagerung abschließen</button>

  </div>
</template>

<script>
import { inject } from 'vue'
import WorkflowNotes from "@/components/WorkflowNotes.vue";
import dayjs from "dayjs";
import axios from "axios";
import CryptoJS from "crypto-js";

export default {
  name: "BagList",
  components: {
    WorkflowNotes,
  },
  data() {
    return {
      workflowStep: 10,
      grossWeight: null,
      grossWeightDate: null,
      grossWeightTime: null,
      scaleData: {
        grossWeightOutput: null,
        grossWeightResult: null,
        grossWeightCheckDigit: null,
        tareWeightOutput: null,
        tareWeightResult: null,
        tareWeightCheckDigit: null,
      },
      licensePlateNumber: null,
      tareWeight: null,
      tareWeightDate: null,
      tareWeightTime: null,
      breed: null,
      sampleNumber: '',
      dockage: null,
      moisture: null,
      hectoliter: null,
      protein: null,
      stockLocation: null,
      stockSites: [],
      sitePrefixes: ['🔵','🟤','🟣'],
      noteData: {
        text: '',
        images: null,
      },
      storedData: false,
      globalFunctions: inject('globalFunctions')
    }
  },
  props: {
    batch: {
      type: Object,
      required: true
    },
    canWrite: {
      type: Boolean,
      required: true
    },
  },
  created() {
    const batch = this.$props.batch
    this.fillForm(batch)
    this.createToken()
  },
  async mounted() {
    //const batch = this.$props.batch
    //console.log(batch)
  },
  computed: {
    showBruttoTara() {
      //return false
      return this.$store.getters.incomingBruttoTara
    },
    showBatchSampleNumber() {
      return this.$store.getters.batchSampleNumber
    },
    isPumpkin() {
      return this.$props.batch.productId == 1
    },
    isGrain() {
      return this.$props.batch.productId > 1
    },
    stores() {
      return this.$store.getters.stores
    },
  },
  methods: {
    fillForm(batch) {
      if (!batch) return
      this.grossWeight = batch.grossWeight
      this.licensePlateNumber = batch.licensePlateNumber
      this.tareWeight = batch.tareWeight
      this.breed = batch.breed
      this.sampleNumber = batch.sampleNumber
      this.dockage = batch.dockage > 0 ? batch.dockage : ''
      this.moisture = batch.moisture > 0 ? batch.moisture : ''
      this.hectoliter = batch.hectoliter > 0 ? batch.hectoliter : ''
      this.protein = batch.protein > 0 ? batch.protein : ''
      this.stockLocation = batch.stockLocation

      if (batch.grossWeightDateTime) this.setFieldDateTime('grossWeight', batch.grossWeightDateTime)
      if (batch.tareWeightDateTime) this.setFieldDateTime('tareWeight', batch.tareWeightDateTime)
      if (batch.comment) {
        const comment = batch.comment.find(comment => comment.workflowState == 10)
        if (comment) this.noteData.text = comment.comment
      }
    },
    totalWeight() {
      return this.grossWeight - this.tareWeight
    },
    totalMinusDockage() {
      const total = this.totalWeight()
      return total - (total * this.dockage / 100)
    },
    async storeWorkflowData() {
      this.storedData = false

      const data = this.getFormData()

      const response = await this.$store.dispatch('uploadItem',
          {name: 'batch', id: this.batch.batchId, data})

      if (response && response.success) {
        this.storedData = true
      }
    },
    async finishWorkflowStep() {
      await this.storeWorkflowData()

      const data = {
        finishWorkflowStep: this.workflowStep,
      }

      const response = await this.$store.dispatch('cruItem',
          {name: 'batch', id: this.batch.batchId, data})

      if (response && response.success) {

        const data = this.getFormData()

        this.$emit('finishedWorkflowStep', { data: {
          ...data,
          workflowState: response.workflowState,
        }});
      }
    },
    getFormData() {
      const data = {
        workflowStep: this.workflowStep,
        noteText: this.noteData.text,
        noteImages: this.noteData.images,
      }

      if (this.isPumpkin) {
        data.breed = this.breed
      }
      if (this.isGrain) {
        data.dockage = this.dockage
        data.protein = this.protein
        data.moisture = this.moisture
        data.hectoliter = this.hectoliter
      }
      if (this.showBatchSampleNumber) {
        data.sampleNumber = this.sampleNumber
      }
      if (this.showBruttoTara || this.isGrain) {
        data.grossWeight = this.grossWeight
        data.grossWeightDate = this.grossWeightDate
        data.grossWeightTime = this.grossWeightTime
        data.licensePlateNumber = this.licensePlateNumber
        data.tareWeight = this.tareWeight
        data.tareWeightDate = this.tareWeightDate
        data.tareWeightTime = this.tareWeightTime
        data.stockLocation = this.stockLocation
      }

      if (this.scaleData.grossWeightResult) {
        data.grossWeightScale = this.scaleData.grossWeightResult;
        data.grossWeightCheckDigit = this.scaleData.grossWeightCheckDigit;
      }
      if (this.scaleData.tareWeightResult) {
        data.tareWeightScale = this.scaleData.tareWeightResult;
        data.tareWeightCheckDigit = this.scaleData.tareWeightCheckDigit;
      }

      return data
    },
    saveForm() {
    },
    setGrossDateTime() {
      if (!this.grossWeightDate) this.grossWeightDate = dayjs().format('DD.MM.YYYY')
      if (!this.grossWeightTime) this.grossWeightTime = dayjs().format('HH:mm')
    },
    setTaraDateTime() {
      if (!this.tareWeightDate) this.tareWeightDate = dayjs().format('DD.MM.YYYY')
      if (!this.tareWeightTime) this.tareWeightTime = dayjs().format('HH:mm')
    },
    setFieldDateTime(field, datetime) {
      if (datetime) {
        const customParseFormat = require('dayjs/plugin/customParseFormat')
        dayjs.extend(customParseFormat)
        this[field +'Date'] = dayjs(datetime + ' +00:00', 'YYYY-MM-DD HH:mm:ss Z').format('DD.MM.YYYY')
        this[field +'Time'] = dayjs(datetime + ' +00:00', 'YYYY-MM-DD HH:mm:ss Z').format('HH:mm')
      } else {
        this[field +'Date'] = dayjs().format('DD.MM.YYYY')
        this[field +'Time'] = dayjs().format('HH:mm')
      }
    },

    async getWeightFromScale(type) {
      this.scaleData[type +'Output'] = 'Verbinde. Warte auf Antwort...'
      let response = null
      // let logMessage = ''

      try {
        response = await axios.get('http://localhost:49321/api/send-weighing-cmd', {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        });

        this.scaleData[type +'Output'] = response.data; // Handle response data

        let responseData = typeof response.data === 'object' ? response.data : JSON.parse(response.data);
        this.scaleData[type +'Result'] = responseData.response;
        // clear multiple spaces into single space
        responseData.response = responseData.response.replaceAll('       ', '*');
        responseData.response = responseData.response.replaceAll('      ', '*');
        responseData.response = responseData.response.replaceAll('     ', '*');
        responseData.response = responseData.response.replaceAll('    ', '*');
        responseData.response = responseData.response.replaceAll('   ', '*');
        responseData.response = responseData.response.replaceAll('  ', '*');
        responseData.response = responseData.response.replaceAll(' ', '*');

        const responseParts = responseData.response.split('*');
        this.scaleData[type +'Output'] = 'Gewicht von Waage eingelesen.';
        this[type] = responseParts[4].slice(0, -2);
        this.scaleData[type +'CheckDigit'] = responseParts[6].slice(0, -5);

        // logMessage = JSON.stringify(response.data);
      } catch (error) {
        this.scaleData[type +'Output'] = `Error: ${error.message}`; // Handle error

        // logMessage = JSON.stringify(error.response.data) +"\n\n"+ JSON.stringify(error);
      }

      /* manual test:
      response = "{\"response\":\"<000002.06.2614:08   01    1560       0    1560kg   001   39670>\\r\\n\"}";
      let responseData = JSON.parse(response);
      this.scaleData[type +'Result'] = responseData;
      // clear multiple spaces into single space
      responseData.response = responseData.response.replaceAll('       ', '*');
      responseData.response = responseData.response.replaceAll('      ', '*');
      responseData.response = responseData.response.replaceAll('     ', '*');
      responseData.response = responseData.response.replaceAll('    ', '*');
      responseData.response = responseData.response.replaceAll('   ', '*');
      responseData.response = responseData.response.replaceAll('  ', '*');
      responseData.response = responseData.response.replaceAll(' ', '*');
      responseData.response = responseData.response.replaceAll('<', '');
      responseData.response = responseData.response.replaceAll('>', '');
      responseData.response = responseData.response.replaceAll('\\r', '');
      responseData.response = responseData.response.replaceAll('\\n', '');
      console.log(responseData.response);
      this.scaleData[type +'Output'] = 'Gewicht von Waage eingelesen.';
      this[type] = responseData.response.split('*')[4].slice(0, -2);
      */

    },
    createToken()
    {
      const header = {
        alg: "HS256",
        typ: "JWT"
      };

      const payload = {
        data: "examplePayload",
        exp: Math.floor(Date.now() / 1000) + (60 * 60) // Token expires in 1 hour
      };

      const secret = process.env.VUE_APP_JWT_SECRET;

      // Base64URL encoding function
      const base64UrlEncode = (obj) => {
        // Regular base64 encoding
        const str = btoa(JSON.stringify(obj));
        // Convert to base64url format
        return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      };

      const headerEncoded = base64UrlEncode(header);
      const payloadEncoded = base64UrlEncode(payload);

      // Create the signature using crypto-js
      const signatureInput = `${headerEncoded}.${payloadEncoded}`;
      const signatureWordArray = CryptoJS.HmacSHA256(signatureInput, secret);

      // Convert the signature to base64 and then to base64url
      let signatureBase64 = CryptoJS.enc.Base64.stringify(signatureWordArray);
      const signatureBase64Url = signatureBase64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

      this.token = `${headerEncoded}.${payloadEncoded}.${signatureBase64Url}`;
    },
    getStockLabel(stockLocation) {
      // add emoji color to stock location
      const site = stockLocation.split(' ')[0]
      let idx = this.stockSites.findIndex(name => name === site)

      if (idx === -1) idx = this.stockSites.push(site) - 1

      return this.sitePrefixes[idx] + ' ' + stockLocation
    },
  },
}
</script>